module.exports = __webpack_public_path__ + "img/icon-like-grey.a8aacd47.svg";